import { useLocation } from "react-router-dom";

const useSomenteConsultaOs = () => useLocation().pathname === "/app/os/consultarOs/consulta";

export default useSomenteConsultaOs;
